import {
  postMFAAnswer,
  postMFAAnswerFromForgotPassword,
} from '../../SelfService/Data/SelfServiceDataSource.js'
import { MFA_ANSWERED } from './LoginHelper.js'

export async function makeMfaAnswerCall(
  data,
  loginInput,
  mode,
  handleDisplayChange,
  handleError,
  activityType
) {
  let mfaAnswerFunction = postMFAAnswer
  if (mode === 'fyp') {
    mfaAnswerFunction = postMFAAnswerFromForgotPassword
  }

  const options = {
    data: data,
    loginInput: loginInput,
    activityType: activityType,
  }

  const mfaResponse = await mfaAnswerFunction(options)
  if (mfaResponse && mfaResponse.ok) {
    handleDisplayChange(MFA_ANSWERED, { response: mfaResponse })
  } else {
    const responseText = await mfaResponse.text()
    if (responseText) {
      const data = JSON.parse(responseText)
      if (data.error && data.error.details) {
        handleError(data.error.details.code)
      } else if (data.error && data.error.code) {
        handleError(data.error.code)
      }
    } else {
      handleError()
    }
  }
}
